import React from 'react';
import { motion } from 'framer-motion';
import { Users, FileSignature, Home, HeartCrack, Baby, Landmark } from 'lucide-react';
const services = [{
  icon: HeartCrack,
  title: 'Розірвання шлюбу',
  description: 'Навіть без згоди одного з подружжя або за відсутності контакту. Повний супровід від позову до рішення.'
}, {
  icon: Baby,
  title: 'Стягнення аліментів',
  description: 'Отримання справедливих виплат на утримання дитини. Швидке проходження судових інстанцій.'
}, {
  icon: Landmark,
  title: 'Зміна розміру аліментів',
  description: 'Збільшення або зменшення розміру виплат залежно від зміни життєвих обставин та доходів.'
}, {
  icon: FileSignature,
  title: 'Зміна способу сплати',
  description: 'Перехід з частки від заробітку на тверду грошову суму або навпаки для вашої вигоди.'
}, {
  icon: Users,
  title: 'Аліменти після 18 років',
  description: 'Стягнення коштів на утримання повнолітньої дитини, яка продовжує навчання (до 23 років).'
}, {
  icon: Home,
  title: 'Поділ майна',
  description: 'Справедливий поділ спільного майна подружжя. Захист ваших активів та нерухомості.'
}];
export function Services() {
  return <section id="services" className="py-32 bg-white" data-id="element-117">
      <div className="container mx-auto px-6" data-id="element-118">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-20 gap-8" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="max-w-2xl" data-id="element-120">
            <h2 className="text-4xl md:text-5xl font-normal tracking-tight text-neutral-900 mb-6" data-id="element-121">
              Моя <span className="font-semibold" data-id="element-122">експертиза</span>
            </h2>
            <p className="text-xl text-neutral-600 font-normal" data-id="element-123">
              Вузька спеціалізація на сімейному праві дозволяє знаходити вихід
              навіть із найскладніших ситуацій.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-124">
          {services.map((service, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="group p-10 bg-white border border-neutral-200 hover:border-neutral-900 transition-colors duration-300" data-id="element-125">
              <service.icon className="w-8 h-8 text-neutral-900 mb-8" strokeWidth={1.5} data-id="element-126" />
              <h3 className="text-xl font-semibold text-neutral-900 mb-4" data-id="element-127">
                {service.title}
              </h3>
              <p className="text-neutral-600 leading-relaxed font-normal" data-id="element-128">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}